import { render, staticRenderFns } from "./GeneratedProductEdit.vue?vue&type=template&id=2cab9ee2&scoped=true"
import script from "./GeneratedProductEdit.vue?vue&type=script&lang=js"
export * from "./GeneratedProductEdit.vue?vue&type=script&lang=js"
import style0 from "./GeneratedProductEdit.vue?vue&type=style&index=0&id=2cab9ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab9ee2",
  null
  
)

export default component.exports